import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';
import { checkTokens } from './guard.functions';

@Injectable()
export class ResumeSessionGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store,
    private api: ApiService
  ) {}

  canActivate(): Observable<boolean> | boolean {
    return checkTokens('resume', this.store, this.api, this.router);
  }
}
